/* TARA EDITION — pre-launch page behaviour.
   Markup: sections/te-prelaunch.liquid, snippets/te-subscribe.liquid
   Strings: the JSON in #te-pre-i18n (tara.pre.* in the locale files)

   1. UTM parameters → customer tags (prelaunch, lang:…, src:…, med:…, cmp:…, cnt:…).
   2. The email posts at once (an ordinary form post), so the address is on the list
      from the first click. The page comes back with a short flow, one step on screen
      at a time:
        confirm  three steps to confirm the one email — or "welcome back" when this
                 browser has signed the same address up before
        number   optional: one or more numbers, on any design
        done     noted
   3. Numbers belong to an email address: a new address starts with none, the same
      address finds its own again and can add, change or clear them. Sending is one
      ordinary post of the list form (so Shopify's form protection adds its token)
      with want:<handle>-<n> tags and the note "Numbers requested: …", the whole
      current list each time.
   4. One Lead / Subscribe event per session; share link; fade-up; [ ENTER ] dialog.
   Events (Fathom when its site ID is set, and Shopify custom pixel events):
   NumberChosen, Subscribe, Share.
   5. Engagement, for Fathom (cookieless, every visitor) and Clarity (once it has
      loaded with consent): "Scroll 25%…100%", "Seen <section>" and
      "Tap <section> · <control>", each once per page view. */
(function () {
  'use strict';

  var UTM_KEYS = [
    ['utm_source', 'src'],
    ['utm_medium', 'med'],
    ['utm_campaign', 'cmp'],
    ['utm_content', 'cnt']
  ];
  var STORE_UTM = 'te-utm';
  var STORE_FORM = 'te-sub-form';
  var STORE_LEAD = 'te-lead-sent';
  var STORE_EMAIL = 'te-email';
  var STORE_DONE = 'te-subscribed';
  var STORE_SLIDE = 'te-slide';
  var STORE_RETURNING = 'te-returning';
  var STORE_PENDING = 'te-number-pending';
  var KNOWN = 'te-known-emails'; // localStorage: addresses this browser has signed up

  var i18n = {};
  try {
    i18n = JSON.parse((document.getElementById('te-pre-i18n') || {}).textContent || '{}');
  } catch (e) {
    i18n = {};
  }
  function t(key, vars) {
    var s = i18n[key] || '';
    Object.keys(vars || {}).forEach(function (k) {
      s = s.split('{' + k + '}').join(vars[k]);
    });
    return s;
  }

  function track(name, props) {
    try {
      if (window.fathom && typeof window.fathom.trackEvent === 'function') window.fathom.trackEvent(name);
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('te_' + name.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase(), props || {});
      }
    } catch (e) {
      /* analytics is optional */
    }
  }

  function store(action, key, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      /* storage can be blocked; the page works without it */
    }
    return null;
  }

  function clean(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 32);
  }

  function local(action, key, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* storage can be blocked */
    }
    return null;
  }

  /* ---- 1. UTM → tags ---- */
  function utmTags() {
    var params = new URLSearchParams(window.location.search);
    var saved = {};
    try {
      saved = JSON.parse(store('get', STORE_UTM) || '{}') || {};
    } catch (e) {
      saved = {};
    }
    var found = false;
    var current = {};
    UTM_KEYS.forEach(function (pair) {
      var v = clean(params.get(pair[0]));
      if (v) {
        current[pair[1]] = v;
        found = true;
      }
    });
    var utm = found ? current : saved;
    if (found) store('set', STORE_UTM, JSON.stringify(current));

    var tags = ['prelaunch'];
    var lang = clean(document.documentElement.lang);
    if (lang) tags.push('lang:' + lang);
    UTM_KEYS.forEach(function (pair) {
      if (utm[pair[1]]) tags.push(pair[1] + ':' + utm[pair[1]]);
    });
    return tags.join(', ');
  }

  /* The numbers chosen, per email address, kept in this browser:
     { email: { handle: { title, numbers[] } } }, and what was last sent for it.
     A new address starts with none; the same address finds its own again. */
  var BY_EMAIL = 'te-numbers-by-email';
  var SENT = 'te-numbers-sent';
  function readMap(key) {
    try { return JSON.parse(local('get', key) || '{}') || {}; } catch (e) { return {}; }
  }
  function currentEmail() {
    return (store('get', STORE_EMAIL) || '').toLowerCase();
  }
  var chosen = readMap(BY_EMAIL)[currentEmail()] || {};

  function saveChosen() {
    var email = currentEmail();
    if (!email) return;
    var map = readMap(BY_EMAIL);
    map[email] = chosen;
    local('set', BY_EMAIL, JSON.stringify(map));
  }

  function sentText() {
    return readMap(SENT)[currentEmail()] || '';
  }

  function chosenTags() {
    var tags = [];
    Object.keys(chosen).forEach(function (handle) {
      chosen[handle].numbers.forEach(function (n) {
        tags.push('want:' + clean(handle) + '-' + clean(n));
      });
    });
    return tags;
  }

  function chosenText() {
    return Object.keys(chosen)
      .filter(function (h) { return chosen[h].numbers.length; })
      .map(function (h) {
        return chosen[h].title + ' ' + chosen[h].numbers.map(function (n) { return 'N° ' + n; }).join(', ');
      })
      .join(' · ');
  }

  function applyTags() {
    var value = [utmTags()].concat(chosenTags()).join(', ');
    var text = chosenText();
    document.querySelectorAll('[data-te-tags]').forEach(function (input) {
      input.value = value;
    });
    document.querySelectorAll('[data-te-note]').forEach(function (input) {
      input.value = text ? 'Numbers requested: ' + text : '';
    });
    document.querySelectorAll('[data-te-chosen]').forEach(function (p) {
      var c = chosen[p.getAttribute('data-te-chosen')];
      p.textContent = c && c.numbers.length ? t('your_choice', { choice: c.numbers.map(function (n) { return 'N° ' + n; }).join(', ') }) : '';
    });
    document.querySelectorAll('[data-te-tab-chosen]').forEach(function (el) {
      var c = chosen[el.getAttribute('data-te-tab-chosen')];
      el.textContent = c && c.numbers.length ? c.numbers.map(function (n) { return 'N° ' + n; }).join(' ') : '';
    });
    var summary = document.querySelector('[data-te-summary-all]');
    if (summary) summary.textContent = text ? t('summary', { choice: text }) : t('summary_none');
    // Send when the list differs from what was last sent: new numbers, changes, or clearing them
    var send = document.querySelector('[data-te-send]');
    if (send) send.disabled = text === sentText();
  }

  function setChosen(d) {
    if (!d || !d.handle) return;
    if (d.numbers && d.numbers.length) chosen[d.handle] = { title: d.title || d.handle, numbers: d.numbers.slice() };
    else delete chosen[d.handle];
    saveChosen();
    applyTags();
  }

  /* ---- 2. The flow after the post, one step at a time ---- */
  var flow = document.querySelector('[data-te-thanks]');
  var step2 = document.querySelector('[data-te-step2]');

  function showSlide(name, focus) {
    if (!flow) return;
    var slides = flow.querySelectorAll('[data-te-slide]');
    var found = false;
    slides.forEach(function (sl) { if (sl.getAttribute('data-te-slide') === name) found = true; });
    if (!found) name = 'confirm';
    slides.forEach(function (sl) {
      var on = sl.getAttribute('data-te-slide') === name;
      sl.classList.toggle('is-active', on);
      sl.hidden = !on;
    });
    var order = ['email', 'confirm', 'number'];
    var at = order.indexOf(name === 'done' ? 'number' : name);
    flow.querySelectorAll('[data-te-flow-dot]').forEach(function (dot) {
      var i = order.indexOf(dot.getAttribute('data-te-flow-dot'));
      dot.classList.toggle('is-done', i < at || name === 'done');
      dot.classList.toggle('is-current', i === at && name !== 'done');
    });
    store('set', STORE_SLIDE, name);
    if (focus) {
      var target = flow.querySelector('[data-te-slide="' + name + '"]');
      var r = flow.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) flow.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (target) {
        var h = target.querySelector('h2');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }
    }
  }

  function flowButtons() {
    if (!flow) return;
    flow.querySelectorAll('[data-te-go]').forEach(function (b) {
      // The number picker's own → button also carries data-te-go (3 Nov 2026: it sent the
      // visitor back to the first step); only the flow's step buttons move between steps
      if (b.closest('te-number-picker')) return;
      b.addEventListener('click', function () { showSlide(b.getAttribute('data-te-go'), true); });
    });
    var send = flow.querySelector('[data-te-send]');
    if (send) send.addEventListener('click', sendNumbers);
  }

  function knownEmail() {
    var typed = document.querySelector('[data-te-num-email]');
    if (typed && typed.value.trim()) return typed.value.trim();
    return store('get', STORE_EMAIL) || '';
  }

  /* Every post goes through the browser's own submit, so Shopify's form protection
     can add its CAPTCHA token (a background request has none and is refused). */
  function submit(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  /* Shopify's form protection only attaches its CAPTCHA to a form once something inside
     that form is focused or changed; until then it silently cancels the form's submit.
     The number step posts the list form (te-sub-1) without the visitor ever touching it
     (a returning visitor on /pages/first-access, everyone on /pages/choose-your-number),
     so wake it as soon as she types her email or picks a number. 3 Nov 2026. */
  function wakeListForms() {
    document.querySelectorAll('[data-te-form]').forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      if (!input) return;
      input.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-te-num-email]')) wakeListForms();
  });
  document.addEventListener('te:numbers-change', wakeListForms);

  var sending = false;
  /* One ordinary post of the list form with the whole current list: want: tags for
     every number and the note "Numbers requested: …" (or "none" when cleared). */
  function sendNumbers() {
    if (sending) return;
    var email = knownEmail();
    var listForm = document.getElementById(store('get', STORE_FORM) || 'te-sub-1') || document.getElementById('te-sub-1');
    var err = document.querySelector('[data-te-send-error]');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      var row = document.querySelector('[data-te-num-email-row]');
      if (row) row.hidden = false;
      var input = document.querySelector('[data-te-num-email]');
      if (input) input.focus();
      if (err) { err.textContent = t('email_needed'); err.hidden = false; }
      return;
    }
    sending = true;
    if (err) err.hidden = true;
    if (email.toLowerCase() !== currentEmail()) {
      store('set', STORE_EMAIL, email.toLowerCase());
      saveChosen();
    }
    applyTags();
    var text = chosenText();
    var count = chosenTags().length;
    // Shopify Forms updates an address that is already on the list; the list form does not
    if (formsEmbed()) {
      var send = document.querySelector('[data-te-send]');
      if (send) send.disabled = true;
      formsSend(email, text || 'none', function (ok) {
        sending = false;
        if (!ok) {
          if (send) send.disabled = false;
          if (err) { err.textContent = t('send_failed'); err.hidden = false; }
          return;
        }
        var sent = readMap(SENT);
        sent[currentEmail()] = text;
        local('set', SENT, JSON.stringify(sent));
        applyTags();
        track('NumberChosen', { count: count });
        showNoted();
        showSlide('done', true);
      });
      return;
    }
    if (!listForm) { sending = false; return; }
    store('set', STORE_PENDING, JSON.stringify({ text: text, count: count }));
    var e = listForm.querySelector('input[type="email"]');
    if (e) e.value = email;
    var note = listForm.querySelector('[data-te-note]');
    if (note && !text) note.value = 'Numbers requested: none';
    store('set', STORE_FORM, listForm.id);
    submit(listForm);
  }

  /* ---- Shopify Forms (form "Pre-launch numbers", block at the foot of the page) ----
     Its form lives in an open shadow root: #email and #tara#requested_numbers (the
     customer metafield tara.requested_numbers). The block is kept off screen; the picker
     fills it and presses its own button, so its CAPTCHA runs as usual. */
  function formsEmbed() {
    return document.querySelector('[data-form-root] shopify-forms-embed');
  }
  function formsParts() {
    var host = formsEmbed();
    var root = host && host.shadowRoot;
    var form = root && root.querySelector('form');
    if (!form) return null;
    return {
      root: root,
      form: form,
      email: root.getElementById('email'),
      numbers: root.getElementById('tara#requested_numbers'),
      button: form.querySelector('button[type="submit"]')
    };
  }
  function setField(input, value) {
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }
  function formsSend(email, numbersText, done) {
    var started = Date.now();
    (function ready() {
      var f = formsParts();
      if (!f || !f.email || !f.numbers || !f.button) {
        if (Date.now() - started > 8000) return done(false);
        return setTimeout(ready, 250);
      }
      setField(f.email, email);
      setField(f.numbers, numbersText);
      var before = f.root.textContent;
      f.button.click();
      // Success: the form gives way to its thank-you text. Failure: an alert, or no answer.
      var t0 = Date.now();
      (function watch() {
        var g = formsParts();
        var alertEl = f.root.querySelector('[role="alert"], [aria-invalid="true"]');
        var noted = f.root.textContent.indexOf('Noted.') > -1 && before.indexOf('Noted.') < 0;
        if (noted || !g || !f.root.contains(f.form) || (f.root.textContent !== before && !alertEl && !f.root.contains(f.button))) return done(true);
        if (alertEl && alertEl.textContent.trim()) return done(false);
        if (Date.now() - t0 > 90000) return done(false);
        setTimeout(watch, 300);
      })();
    })();
  }

  /* The pickers show the numbers saved for this address (or none) */
  function fillPickers(picker) {
    var list = picker ? [picker] : Array.prototype.slice.call(document.querySelectorAll('te-number-picker[data-mode="interest"]'));
    list.forEach(function (el) {
      if (typeof el.setNumbers !== 'function') return;
      var c = chosen[el.getAttribute('data-handle')];
      el.setNumbers(c ? c.numbers : [], true);
    });
    applyTags();
  }

  function numbers() {
    document.addEventListener('te:numbers-change', function (e) { setChosen(e.detail); });
    // A picker that starts after this script is filled when it says it is ready
    document.addEventListener('te:numbers-ready', function (e) { fillPickers(e.target); });
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('te-number-picker').then(function () { fillPickers(); });
    }
  }

  /* Tabs in the number step, and the card links */
  function tabs() {
    var list = Array.prototype.slice.call(document.querySelectorAll('[data-te-hold-tab]'));
    function show(id, focus) {
      list.forEach(function (tab) {
        var on = tab.getAttribute('data-te-hold-tab') === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on && focus) tab.focus();
      });
    }
    list.forEach(function (tab, i) {
      tab.addEventListener('click', function () { show(tab.getAttribute('data-te-hold-tab')); });
      tab.addEventListener('keydown', function (e) {
        var d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (d === undefined) return;
        e.preventDefault();
        show(list[(i + d + list.length) % list.length].getAttribute('data-te-hold-tab'), true);
      });
    });

    // A number in the register strip: the number step once signed up, else the email field
    document.querySelectorAll('[data-te-reg-pick]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (step2 && document.querySelector('.te-sub--done')) {
          showSlide('number', true);
          return;
        }
        focusEmail();
      });
    });

    // A card's [ CHOOSE YOUR NUMBER ]: after signing up it opens that design in the
    // number step; before, it leads to the email field
    document.querySelectorAll('[data-te-hold-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var id = a.getAttribute('data-te-hold-open');
        if (list.length) show(id);
        if (step2 && document.querySelector('.te-sub--done')) {
          showSlide('number', true);
          return;
        }
        focusEmail();
      });
    });
  }

  function focusEmail() {
    var form = document.getElementById('te-sub-1');
    var email = form && form.querySelector('input[type="email"]');
    if (!email || form.classList.contains('te-sub--done')) return;
    var r = email.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) email.scrollIntoView({ behavior: 'smooth', block: 'center' });
    email.focus({ preventScroll: true });
  }

  /* ---- 3. After posting ---- */
  function afterPost() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-te-form]'));
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        store('set', STORE_FORM, form.id);
        var input = form.querySelector('input[type="email"]');
        var email = input && input.value ? input.value.trim().toLowerCase() : '';
        if (!email) return;
        // A number post (sendNumbers) has its tags and note set already; not a new sign-up
        if (store('get', STORE_PENDING)) return;
        // A sign-up carries only this address's own numbers (none for a new address)
        chosen = readMap(BY_EMAIL)[email] || {};
        store('set', STORE_EMAIL, email);
        applyTags();
        var known = [];
        try { known = JSON.parse(local('get', KNOWN) || '[]') || []; } catch (e) { known = []; }
        store('set', STORE_RETURNING, known.indexOf(email) > -1 ? '1' : '');
        if (known.indexOf(email) < 0) { known.push(email); local('set', KNOWN, JSON.stringify(known.slice(-10))); }
        store('set', STORE_SLIDE, 'confirm');
      });
    });

    var posted = /[?&]customer_posted=true\b/.test(window.location.search);
    var withStatus = forms.filter(function (f) {
      return f.querySelector('[data-te-status]');
    });
    if (!posted && !withStatus.length) return;

    // Both forms are type "customer", so both may render the status; keep it on the one used.
    var used = document.getElementById(store('get', STORE_FORM)) || withStatus[0] || forms[0];
    forms.forEach(function (form) {
      if (form === used) return;
      var s = form.querySelector('[data-te-status]');
      if (s) s.hidden = true;
    });

    var status = used && used.querySelector('[data-te-status]');
    var success = status && status.classList.contains('te-sub__ok');
    if (!success) {
      if (status) {
        used.scrollIntoView({ block: 'center' });
        status.focus({ preventScroll: true });
      }
      return;
    }
    store('set', STORE_DONE, '1');

    var pending = null;
    try { pending = JSON.parse(store('get', STORE_PENDING) || 'null'); } catch (e) { pending = null; }
    if (pending) {
      // Back from sending the numbers: remember what this address has sent
      var sent = readMap(SENT);
      sent[currentEmail()] = pending.text;
      local('set', SENT, JSON.stringify(sent));
      store('set', STORE_PENDING, '');
      store('set', STORE_SLIDE, 'done');
      track('NumberChosen', { count: pending.count });
    } else if (posted && !store('get', STORE_LEAD)) {
      store('set', STORE_LEAD, '1');
      track('Subscribe', { form: used.id });
    }
    openFlow(used, status);
  }

  /* The done step's first line: what was noted, or that nothing was */
  function showNoted() {
    var noted = flow && flow.querySelector('[data-te-thanks-noted]');
    if (noted) noted.textContent = chosenText() ? t('noted', { choice: chosenText() }) : t('summary_none');
  }

  /* The form folds away and the flow opens on the step it was on */
  function openFlow(form, status) {
    if (!flow) return;
    form.classList.add('te-sub--done');
    if (status) status.hidden = true;
    if (form.nextElementSibling !== flow) form.parentNode.insertBefore(flow, form.nextSibling);
    var email = store('get', STORE_EMAIL);
    var sent = flow.querySelector('[data-te-thanks-sent]');
    if (sent && email) sent.textContent = t('sent_to', { email: email });
    var row = flow.querySelector('[data-te-num-email-row]');
    if (row && !email) row.hidden = false;
    var returning = store('get', STORE_RETURNING) === '1';
    var isNew = flow.querySelector('[data-te-new]');
    var back = flow.querySelector('[data-te-returning]');
    if (isNew) isNew.hidden = returning;
    if (back) back.hidden = !returning;
    showNoted();
    flow.hidden = false;
    showSlide(store('get', STORE_SLIDE) || 'confirm');
    flow.scrollIntoView({ block: 'start' });
    flow.focus({ preventScroll: true });
  }

  function share() {
    document.querySelectorAll('[data-te-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = window.location.origin + '/';
        var text = btn.getAttribute('data-text') || '';
        var label = btn.textContent;
        track('Share', {});
        if (navigator.share) {
          navigator.share({ title: t('share_title'), text: text, url: url }).catch(function () {});
          return;
        }
        var done = function () {
          btn.textContent = t('link_copied');
          setTimeout(function () { btn.textContent = label; }, 2400);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(text + ' ' + url).then(done, function () {});
        else window.location.href = 'mailto:?subject=' + encodeURIComponent(t('share_title')) + '&body=' + encodeURIComponent(text + '\n' + url);
      });
    });
  }

  /* ---- 4a. Fade-up once ---- */
  function fades() {
    var els = document.querySelectorAll('[data-te-fade]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('te-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('te-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
    // Anything already on screen at load shows straight away
    window.requestAnimationFrame(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('te-in');
      });
    });
  }

  /* ---- 4b. [ ENTER ] password dialog ---- */
  function enterDialog() {
    var dialog = document.getElementById('te-enter');
    var open = document.querySelector('[data-te-enter]');
    if (!dialog || !open || typeof dialog.showModal !== 'function') return;
    var close = dialog.querySelector('[data-te-enter-close]');

    open.addEventListener('click', function () {
      dialog.showModal();
      var field = dialog.querySelector('input[type="password"]');
      if (field) field.focus();
    });
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () { open.focus(); });

    // A wrong password reloads the page with the error inside the dialog: reopen it
    if (dialog.querySelector('[data-te-enter-error]')) dialog.showModal();
  }

  // Scarf cards on touch screens: keep the 1/2 counter and dots in step with the swipe
  function carousels() {
    document.querySelectorAll('[data-te-carousel]').forEach(function (track) {
      var card = track.closest('.te-card');
      var count = card && card.querySelector('[data-te-count]');
      var dots = card ? card.querySelectorAll('[data-te-dots] i') : [];
      if (!count && !dots.length) return;
      var current = -1;
      function update() {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i === current) return;
        current = i;
        if (count) count.textContent = (i + 1) + '/' + (dots.length || 1);
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === i);
      }
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ---- 5. engagement: scroll depth, sections seen, taps ---- */
  function engagement() {
    var sent = {};
    function once(name) {
      if (sent[name]) return;
      sent[name] = true;
      try {
        if (window.fathom && typeof window.fathom.trackEvent === 'function') window.fathom.trackEvent(name);
        if (typeof window.clarity === 'function') window.clarity('event', name);
      } catch (e) {
        /* analytics is optional */
      }
    }

    var SECTIONS = [
      ['.te-strip', 'Top bar'],
      ['.te-hero', 'Hero'],
      ['[data-te-slide="confirm"]', 'Step confirm'],
      ['[data-te-slide="number"]', 'Step number'],
      ['[data-te-slide="done"]', 'Step done'],
      ['.te-edition', 'Edition'],
      ['.te-details', 'Details'],
      ['.te-graft', 'Graft'],
      ['.te-about', 'About'],
      ['.te-connect', 'Sign-up'],
      ['.te-foot', 'Footer']
    ];
    function sectionOf(el) {
      for (var i = 0; i < SECTIONS.length; i++) if (el.closest(SECTIONS[i][0])) return SECTIONS[i][1];
      return el.closest('dialog') ? 'Dialog' : 'Page';
    }

    /* scroll depth */
    var marks = [25, 50, 75, 100];
    var ticking = false;
    function depth() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 100;
      marks.forEach(function (m) { if (pct >= m - 1) once('Scroll ' + m + '%'); });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(depth); }
    }, { passive: true });

    /* sections seen: 40 % of the section (or of the screen, for tall ones) in view */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var r = e.intersectionRect.height;
          if (e.isIntersecting && (e.intersectionRatio >= 0.4 || r >= window.innerHeight * 0.4)) {
            once('Seen ' + e.target.getAttribute('data-te-seen'));
            io.unobserve(e.target);
          }
        });
      }, { threshold: [0, 0.2, 0.4, 0.6] });
      SECTIONS.forEach(function (s) {
        var el = document.querySelector(s[0]);
        if (el && !el.hasAttribute('data-te-slide')) { el.setAttribute('data-te-seen', s[1]); io.observe(el); }
      });
    }

    /* taps: a stable name per control, the same in every language */
    var NAMES = {
      'data-te-pick': 'Pick for me', 'data-te-go': 'Choose number', 'data-te-browse-btn': 'See all numbers',
      'data-te-add': 'Done', 'data-te-more': 'Add another', 'data-te-hold-open': 'Reserve',
      'data-te-reg-pick': 'Register number', 'data-te-share': 'Share', 'data-te-lang': 'Language',
      'data-te-submit': 'Sign up', 'data-te-send': 'Send numbers', 'data-te-hold-tab': 'Scarf tab',
      'data-te-enter': 'Enter', 'data-te-enter-close': 'Close', 'data-te-new': 'New address'
    };
    function controlName(el) {
      for (var k in NAMES) if (el.hasAttribute(k)) return NAMES[k];
      if (el.classList.contains('te-num__cell')) return 'Number cell';
      if (el.tagName === 'A') {
        var href = el.getAttribute('href') || '';
        if (href.charAt(0) === '#') return 'Link ' + href;
        try {
          var u = new URL(href, location.href);
          return 'Link ' + (u.host === location.host ? u.pathname.replace(/^\/(nl|de|fr|es|it)(?=\/)/, '') : u.host);
        } catch (e) { return 'Link'; }
      }
      if (el.type === 'submit') return 'Submit';
      return 'Button';
    }
    document.addEventListener('click', function (e) {
      var el = e.target.closest('a, button, summary, [role="button"], .te-card[tabindex]');
      if (!el) return;
      var name = el.classList.contains('te-card') ? 'Card photos' : controlName(el);
      var card = el.closest('.te-card');
      var scarf = card && card.querySelector('.te-card__name');
      if (scarf) name += ' (' + scarf.textContent.trim() + ')';
      once('Tap ' + sectionOf(el) + ' · ' + name);
    }, true);
  }

  /* Phones: sticky "Get first access" once the first sign-up has scrolled away (31 Oct 2026).
     Hidden for anyone who signed up in this browser, near the second form, and while the
     cookie banner is open. The button scrolls back to the first form and focuses the field. */
  function stickyJoin() {
    var bar = document.querySelector('[data-te-stick]');
    var form = document.getElementById('te-sub-1');
    var second = document.getElementById('te-sub-2');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-te-stick-btn]');
    var phone = window.matchMedia('(max-width: 767px)');
    var past = false, nearSecond = false;
    function joined() {
      var thanks = document.querySelector('[data-te-thanks]');
      if (thanks && !thanks.hidden) return true;
      var known = local('get', KNOWN);
      return !!(known && known !== '[]');
    }
    function update() {
      var cookie = document.getElementById('shopify-pc__banner');
      var cookieOpen = !!(cookie && cookie.getClientRects().length && getComputedStyle(cookie).visibility !== 'hidden' && getComputedStyle(cookie).display !== 'none');
      /* Shopify's preview bar (theme previews only) sits at the bottom: stay above it */
      var pb = document.getElementById('PBarNextFrameWrapper');
      var pr = pb && pb.getClientRects().length ? pb.getBoundingClientRect() : null;
      bar.style.bottom = pr && pr.height && pr.top < window.innerHeight ? Math.max(0, window.innerHeight - pr.top) + 'px' : '';
      var on = phone.matches && past && !nearSecond && !cookieOpen && !joined();
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (e) {
      past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      update();
    }).observe(form);
    if (second) new IntersectionObserver(function (e) { nearSecond = e[0].isIntersecting; update(); }, { rootMargin: '0px 0px 160px 0px' }).observe(second);
    phone.addEventListener('change', update);
    setInterval(update, 1500);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var field = form.querySelector('input[type="email"]');
      if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 500);
      track('StickyFirstAccess');
    });
  }

  /* The page goes on (31 Oct 2026). Desktop: the hairline cue at the foot of the hero fades once
     the visitor scrolls. Phones: no mark; once per visit, after a few idle seconds at the top, the
     page lifts a little and settles back, so it is clear there is more below. Any touch, scroll,
     key or focus first cancels it; reduced-motion visitors never see it. */
  function scrollCue() {
    var cue = document.querySelector('[data-te-cue]');
    if (cue) {
      var gone = function () { if (window.scrollY > 40) { cue.classList.add('is-gone'); window.removeEventListener('scroll', gone); } };
      window.addEventListener('scroll', gone, { passive: true });
      cue.addEventListener('click', function (e) {
        var to = document.getElementById('te-edition-title');
        if (!to) return;
        e.preventDefault();
        to.scrollIntoView({ behavior: 'smooth', block: 'start' });
        track('ScrollCue');
      });
    }
    var phone = window.matchMedia('(max-width: 767px)').matches;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!phone || still || window.scrollY > 0 || store('get', 'te-cue')) return;
    var timer;
    var cancel = function () {
      clearTimeout(timer);
      ['touchstart', 'scroll', 'keydown', 'focusin', 'wheel'].forEach(function (t) { window.removeEventListener(t, cancel, true); });
    };
    ['touchstart', 'scroll', 'keydown', 'focusin', 'wheel'].forEach(function (t) { window.addEventListener(t, cancel, { capture: true, passive: true }); });
    timer = setTimeout(function () {
      cancel();
      store('set', 'te-cue', '1');
      window.scrollTo({ top: 64, behavior: 'smooth' });
      setTimeout(function () { if (window.scrollY <= 80) window.scrollTo({ top: 0, behavior: 'smooth' }); }, 650);
    }, 3200);
  }

  function init() {
    carousels();
    applyTags();
    numbers();
    tabs();
    flowButtons();
    share();
    afterPost();
    fades();
    enterDialog();
    engagement();
    stickyJoin();
    scrollCue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
